import { useCommon } from 'src/domains/common/Common';
import { LanguagesState } from 'src/domains/layouts/state/languagesState/LanguagesState';
import { DateTime } from 'src_common/utils/time/time';

export function isToday(time: string): boolean {
    const today = DateTime.from(time)?.startOfDays();
    if (today === undefined) {
        console.error('Today value is undefined. Time: ', time);
        return false;
    }
    return DateTime.current().startOfDays().isSameDay(today);
}

export function isTomorrow(time: string): boolean {
    const tomorrow = DateTime.from(time)?.startOfDays();
    if (tomorrow === undefined) {
        console.error('Tomorrow value is undefined. Time: ', time);
        return false;
    }
    return DateTime.current().startOfDays().addDays(1).isSameDay(tomorrow);
}

export function getSimpleDate(time: string, language: LanguagesState): string {
    const currentTime = DateTime.from(time);
    if (currentTime === null) {
        return '';
    }
    return (
        (isToday(time)
            ? language.getTranslation('events.time-options.today', 'Today')
            : currentTime.format('ddd DD MMM')) + currentTime.format(' HH:mm')
    );
}

export function getSimpleDateTodayTomorrow(time: string, language: LanguagesState): string {
    const currentTime = DateTime.from(time);

    if (currentTime === null) {
        return '';
    }

    return (
        (isToday(time) === true
            ? language.getTranslation('events.time-options.today', 'Today')
            : isTomorrow(time) === true
              ? language.getTranslation('events.time-options.tomorrow', 'Tomorrow')
              : currentTime.format('ddd DD MMM')) + currentTime.format(' HH:mm')
    );
}

export function getSimpleDateUnified(
    time: string,
    getTranslation: (key: string, defaultText: string) => string
): string {
    const currentTime = DateTime.from(time);
    if (currentTime === null) {
        return '';
    }
    return isToday(time) ? getTranslation('events.time-options.today', 'Today') : currentTime.format('ddd DD MMM');
}

export function getSimpleDateOutrights(time: string, language?: LanguagesState): string {
    const common = useCommon();
    const currentTime = DateTime.from(time);
    if (currentTime === null) {
        return '';
    }
    return isToday(time)
        ? (language || LanguagesState.get(common)).getTranslation('events.time-options.today', 'Today')
        : currentTime.format('Do MMM') + currentTime.format(' HH:mm');
}
